import { inject as f } from "vue";
import { k as i } from "./helper-BIBe7yYh.js";
const u = Symbol.for("torusui:icons"), g = (n) => `${i(n)}`, a = (n) => ({ install: (o) => {
  const l = () => {
    const t = {};
    return Object.entries(n || {}).forEach(([r, s]) => {
      t[i(r)] = s;
    }), t;
  }, { mount: c } = o;
  o.mount = (t, r, s) => {
    o.provide(u, l());
    const m = c(t, r, s);
    return o.mount = c, m;
  };
} }), d = () => {
  const n = f(u);
  if (!n) throw new Error("Missing Torus Icons provided");
  function e(o) {
    return n[o] ? n[o] : (console.error(`Missing Icon name give ${o}`), null);
  }
  return { getIcon: e };
};
export {
  a as createIcons,
  g as getIconName,
  d as useIcons
};
//# sourceMappingURL=icons.esm.js.map
